/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const JSG = require('./src/JSG');

const Dictionary = require('./src/commons/Dictionary');
const ImagePool = require('./src/commons/ImagePool');
const TemplateStore = require('./src/graph/attr/TemplateStore');
const Point = require('./src/geometry/Point');
const CommandFactory = require('./src/graph/command/CommandFactory');
const IdUpdater = require('./src/graph/model/IdUpdater');
const GraphParser = require('./src/graph/parser/GraphParser');

Object.assign(JSG.jsg, {
	min_width_height: 50,
	propertyEventsDisabled: false,
	/* eslint-disable */
	fontMetricsCache: new Dictionary(),
	imagePool: new ImagePool(),
	tmplStore: new TemplateStore(),
	clipOffset: new Point(0,0),
	commandFactory: new CommandFactory(),
	dpi: new Point(72, 72),
	idUpdater: new IdUpdater(),
	FormulaParser: new GraphParser()
	/* eslint-enable */
});

module.exports = JSG;

JSG.ChartAxis = require('./src/graph/model/chart/ChartAxis');
JSG.ChartRect = require('./src/graph/model/chart/ChartRect');
JSG.ChartFormat = require('./src/graph/model/chart/ChartFormat');
JSG.ChartDataLabel = require('./src/graph/model/chart/ChartDataLabel');
JSG.ChartMarker = require('./src/graph/model/chart/ChartMarker');
JSG.ChartMap = require('./src/graph/model/chart/ChartMap');
JSG.Chart = require('./src/graph/model/chart/Chart');
JSG.ChartTitle = require('./src/graph/model/chart/ChartTitle');
JSG.ChartSeries = require('./src/graph/model/chart/ChartSeries');
JSG.ChartPoint = require('./src/graph/model/chart/ChartPoint');
JSG.MessageBoxReference = require('./src/graph/parser/MessageBoxReference');
JSG.SheetReference = require('./src/graph/parser/SheetReference');
JSG.ObjectFactory = require('./src/ObjectFactory');
JSG.Math = require('./src/commons/Math');
JSG.Arrays = require('./src/commons/Arrays');
JSG.Numbers = require('./src/commons/Numbers');
JSG.Strings = require('./src/commons/Strings');
JSG.Dictionary = require('./src/commons/Dictionary');
JSG.StableDictionary = require('./src/commons/StableDictionary');
JSG.ImagePool = require('./src/commons/ImagePool');
JSG.XML = require('./src/commons/XML');
JSG.Writer = require('./src/commons/Writer');
JSG.JSONWriter = require('./src/commons/JSONWriter');
JSG.Reader = require('./src/commons/Reader');
JSG.JSONReader = require('./src/commons/JSONReader');
JSG.Point = require('./src/geometry/Point');
JSG.Rectangle = require('./src/geometry/Rectangle');
JSG.PointList = require('./src/geometry/PointList');
JSG.Matrix = require('./src/geometry/Matrix');
JSG.BoundingBox = require('./src/geometry/BoundingBox');
JSG.MathUtils = require('./src/geometry/MathUtils');
JSG.CoordinateSystem = require('./src/geometry/CoordinateSystem');
JSG.MetricCoordinateSystem = require('./src/geometry/MetricCoordinateSystem');
JSG.GraphReference = require('./src/graph/parser/GraphReference');
JSG.AttributeReference = require('./src/graph/parser/AttributeReference');
JSG.ReferenceFactory = require('./src/graph/parser/ReferenceFactory');
JSG.GraphParser = require('./src/graph/parser/GraphParser');
JSG.GraphParserContext = require('./src/graph/parser/GraphParserContext');
JSG.GraphReference = require('./src/graph/parser/GraphReference');
JSG.Expression = require('./src/graph/expr/Expression');
JSG.ExpressionProxy = require('./src/graph/expr/ExpressionProxy');
JSG.ExpressionConstraint = require('./src/graph/expr/ExpressionConstraint');
JSG.ConstExpression = require('./src/graph/expr/ConstExpression');
JSG.BooleanExpression = require('./src/graph/expr/BooleanExpression');
JSG.NumberExpression = require('./src/graph/expr/NumberExpression');
JSG.StringExpression = require('./src/graph/expr/StringExpression');
JSG.ObjectExpression = require('./src/graph/expr/ObjectExpression');
JSG.MapExpression = require('./src/graph/expr/MapExpression');
JSG.AttributeExpression = require('./src/graph/expr/AttributeExpression');
JSG.BooleanConstraint = require('./src/graph/expr/BooleanConstraint');
JSG.NumberConstraint = require('./src/graph/expr/NumberConstraint');
JSG.RangeConstraint = require('./src/graph/expr/RangeConstraint');
JSG.NumberRangeConstraint = require('./src/graph/expr/NumberRangeConstraint');
JSG.ObjectConstraint = require('./src/graph/expr/ObjectConstraint');
JSG.StringConstraint = require('./src/graph/expr/StringConstraint');
JSG.Pin = require('./src/graph/Pin');
JSG.Size = require('./src/graph/Size');
JSG.Coordinate = require('./src/graph/Coordinate');
JSG.CoordinateProxy = require('./src/graph/CoordinateProxy');
JSG.BezierCoordinate = require('./src/graph/BezierCoordinate');
JSG.BezierCoordinateProxy = require('./src/graph/BezierCoordinateProxy');
JSG.PortCoordinateProxy = require('./src/graph/PortCoordinateProxy');
JSG.ReshapeCoordinate = require('./src/graph/ReshapeCoordinate');
JSG.GraphUtils = require('./src/graph/GraphUtils');
JSG.Event = require('./src/graph/model/events/Event');
JSG.ShapeEvent = require('./src/graph/model/events/ShapeEvent');
JSG.NodeEvent = require('./src/graph/model/events/NodeEvent');
JSG.EventListener = require('./src/graph/model/events/EventListener');
JSG.EventDispatcher = require('./src/graph/model/events/EventDispatcher');
JSG.AttributeChangeEvent = require('./src/graph/model/events/AttributeChangeEvent');
JSG.AttributeListener = require('./src/graph/model/events/AttributeListener');
JSG.FormatListener = require('./src/graph/model/events/FormatListener');
JSG.GraphItemListener = require('./src/graph/model/events/GraphItemListener');
JSG.ShapeListener = require('./src/graph/model/events/ShapeListener');
JSG.PortListener = require('./src/graph/model/events/PortListener');
JSG.EdgeListener = require('./src/graph/model/events/EdgeListener');
JSG.AttributeUtils = require('./src/graph/attr/AttributeUtils');
JSG.Attribute = require('./src/graph/attr/Attribute');
JSG.ConstAttribute = require('./src/graph/attr/ConstAttribute');
JSG.BooleanAttribute = require('./src/graph/attr/BooleanAttribute');
JSG.NumberAttribute = require('./src/graph/attr/NumberAttribute');
JSG.StringAttribute = require('./src/graph/attr/StringAttribute');
JSG.ObjectAttribute = require('./src/graph/attr/ObjectAttribute');
JSG.AttributeList = require('./src/graph/attr/AttributeList');
JSG.ConstAttributeList = require('./src/graph/attr/ConstAttributeList');
JSG.Template = require('./src/graph/attr/Template');
JSG.ItemAttributes = require('./src/graph/attr/ItemAttributes');
JSG.EdgeAttributes = require('./src/graph/attr/EdgeAttributes');
JSG.TextNodeAttributes = require('./src/graph/attr/TextNodeAttributes');
JSG.LayoutAttributes = require('./src/graph/attr/LayoutAttributes');
JSG.EventAttributes = require('./src/graph/attr/EventAttributes');
JSG.FormatAttributes = require('./src/graph/attr/FormatAttributes');
JSG.TextFormatAttributes = require('./src/graph/attr/TextFormatAttributes');
JSG.TemplateStore = require('./src/graph/attr/TemplateStore');
JSG.AbstractSettings = require('./src/graph/model/settings/AbstractSettings');
JSG.GraphSettingsEvent = require('./src/graph/model/settings/GraphSettingsEvent');
JSG.CustomSetting = require('./src/graph/model/settings/CustomSetting');
JSG.GraphSettings = require('./src/graph/model/settings/GraphSettings');
JSG.Layer = require('./src/graph/model/Layer');
JSG.Shape = require('./src/graph/model/shapes/Shape');
JSG.RectangleShape = require('./src/graph/model/shapes/RectangleShape');
JSG.PolygonShape = require('./src/graph/model/shapes/PolygonShape');
JSG.BezierShape = require('./src/graph/model/shapes/BezierShape');
JSG.EllipseShape = require('./src/graph/model/shapes/EllipseShape');
JSG.LineShape = require('./src/graph/model/shapes/LineShape');
JSG.BezierLineShape = require('./src/graph/model/shapes/BezierLineShape');
JSG.OrthoLineShape = require('./src/graph/model/shapes/OrthoLineShape');
JSG.PathShape = require('./src/graph/model/shapes/PathShape');
JSG.BBoxShape = require('./src/graph/model/shapes/BBoxShape');
JSG.ShapeFactory = require('./src/graph/model/shapes/ShapeFactory');
JSG.IdUpdater = require('./src/graph/model/IdUpdater');
JSG.State = require('./src/graph/model/State');
JSG.Model = require('./src/graph/model/Model');
JSG.Path = require('./src/graph/model/Path');
JSG.GraphItem = require('./src/graph/model/GraphItem');
JSG.Graph = require('./src/graph/model/Graph');
JSG.Node = require('./src/graph/model/Node');
JSG.LineNode = require('./src/graph/model/LineNode');
JSG.Port = require('./src/graph/model/Port');
JSG.PortMapper = require('./src/graph/model/PortMapper');
JSG.Section = require('./src/graph/model/Section');
JSG.Paragraph = require('./src/graph/model/Paragraph');
JSG.TextNode = require('./src/graph/model/TextNode');
JSG.LineConnection = require('./src/graph/model/LineConnection');
JSG.Edge = require('./src/graph/model/Edge');
JSG.Group = require('./src/graph/model/Group');
JSG.Command = require('./src/graph/command/Command');
JSG.CommandProxy = require('./src/graph/command/CommandProxy');
JSG.CompoundCommand = require('./src/graph/command/CompoundCommand');
JSG.CommandStack = require('./src/graph/command/CommandStack');
JSG.NoOpCommand = require('./src/graph/command/NoOpCommand');
JSG.ShapePointsMap = require('./src/graph/command/ShapePointsMap');
JSG.AbstractItemCommand = require('./src/graph/command/AbstractItemCommand');
JSG.AbstractItemCommandProxy = require('./src/graph/command/AbstractItemCommandProxy');
JSG.AddItemCommand = require('./src/graph/command/AddItemCommand');
JSG.AddImageCommand = require('./src/graph/command/AddImageCommand');
JSG.AddLabelCommand = require('./src/graph/command/AddLabelCommand');
JSG.AddPortCommand = require('./src/graph/command/AddPortCommand');
JSG.AlignItemsCommand = require('./src/graph/command/AlignItemsCommand');
JSG.ChangeParentCommand = require('./src/graph/command/ChangeParentCommand');
JSG.DropItemCommand = require('./src/graph/command/DropItemCommand');
JSG.InternalMoveItemCommand = require('./src/graph/command/InternalMoveItemCommand');
JSG.MoveNodeCommand = require('./src/graph/command/MoveNodeCommand');
JSG.MoveEdgeCommand = require('./src/graph/command/MoveEdgeCommand');
JSG.MoveItemCommand = require('./src/graph/command/MoveItemCommand');
JSG.TranslateItemsCommand = require('./src/graph/command/TranslateItemsCommand');
JSG.SizeItemsCommand = require('./src/graph/command/SizeItemsCommand');
JSG.InternalResizeItemCommand = require('./src/graph/command/InternalResizeItemCommand');
JSG.ResizeNodeCommand = require('./src/graph/command/ResizeNodeCommand');
JSG.ResizeGroupCommand = require('./src/graph/command/ResizeGroupCommand');
JSG.ResizeItemCommand = require('./src/graph/command/ResizeItemCommand');
JSG.ReshapeItemCommand = require('./src/graph/command/ReshapeItemCommand');
JSG.InternalRotateItemCommand = require('./src/graph/command/InternalRotateItemCommand');
JSG.ReplaceSubItemCommand = require('./src/graph/command/ReplaceSubItemCommand');
JSG.RotateNodeCommand = require('./src/graph/command/RotateNodeCommand');
JSG.RotateEdgeCommand = require('./src/graph/command/RotateEdgeCommand');
JSG.RotateItemCommand = require('./src/graph/command/RotateItemCommand');
JSG.FormatItemCommand = require('./src/graph/command/FormatItemCommand');
JSG.TextFormatItemCommand = require('./src/graph/command/TextFormatItemCommand');
JSG.SetTextCommand = require('./src/graph/command/SetTextCommand');
JSG.SetPointSourceCommand = require('./src/graph/command/SetPointSourceCommand');
JSG.SetSelectionCommand = require('./src/graph/command/SetSelectionCommand');
JSG.SelectCellsCommand = require('./src/graph/command/SelectCellsCommand');
JSG.RemoveSelectionCommand = require('./src/graph/command/RemoveSelectionCommand');
JSG.SetNameCommand = require('./src/graph/command/SetNameCommand');
JSG.SetLinkCommand = require('./src/graph/command/SetLinkCommand');
JSG.GroupCreator = require('./src/graph/command/GroupCreator');
JSG.AbstractGroupUngroupCommand = require('./src/graph/command/AbstractGroupUngroupCommand');
JSG.GroupItemsCommand = require('./src/graph/command/GroupItemsCommand');
JSG.UnGroupItemsCommand = require('./src/graph/command/UnGroupItemsCommand');
JSG.ChangeItemOrderCommand = require('./src/graph/command/ChangeItemOrderCommand');
JSG.ChangeAttributeCommand = require('./src/graph/command/ChangeAttributeCommand');
JSG.AddAttributeCommand = require('./src/graph/command/AddAttributeCommand');
JSG.RemoveAttributeCommand = require('./src/graph/command/RemoveAttributeCommand');
JSG.CollapseItemCommand = require('./src/graph/command/CollapseItemCommand');
JSG.AttachCommand = require('./src/graph/command/AttachCommand');
JSG.DeletePortCommand = require('./src/graph/command/DeletePortCommand');
JSG.InternalDetachCommand = require('./src/graph/command/InternalDetachCommand');
JSG.DetachCommand = require('./src/graph/command/DetachCommand');
JSG.InternalDeleteItemCommand = require('./src/graph/command/InternalDeleteItemCommand');
JSG.DeleteEdgeCommand = require('./src/graph/command/DeleteEdgeCommand');
JSG.MarkCellValuesCommand = require('./src/graph/command/MarkCellValuesCommand');
JSG.ZoomChartCommand = require('./src/graph/command/ZoomChartCommand');
JSG.DeleteNodeCommand = require('./src/graph/command/DeleteNodeCommand');
JSG.DeleteItemCommand = require('./src/graph/command/DeleteItemCommand');
JSG.PasteItemsCommand = require('./src/graph/command/PasteItemsCommand');
JSG.SetShapeCommand = require('./src/graph/command/SetShapeCommand');
JSG.SetShapePointsCommand = require('./src/graph/command/SetShapePointsCommand');
JSG.InsertShapeCoordinateAtCommand = require('./src/graph/command/InsertShapeCoordinateAtCommand');
JSG.RemoveShapeCoordinateAtCommand = require('./src/graph/command/RemoveShapeCoordinateAtCommand');
JSG.SetPinCommand = require('./src/graph/command/SetPinCommand');
JSG.SetSizeCommand = require('./src/graph/command/SetSizeCommand');
JSG.SetLinePointAtCommand = require('./src/graph/command/SetLinePointAtCommand');
JSG.SetLineCoordinateAtCommand = require('./src/graph/command/SetLineCoordinateAtCommand');
JSG.SetLineShapePointsCommand = require('./src/graph/command/SetLineShapePointsCommand');
JSG.SetBezierShapePointsCommand = require('./src/graph/command/SetBezierShapePointsCommand');

const UpdateNamesCommands = require('./src/graph/command/UpdateNamesCommands');
const { RequestCommand, CompoundRequestCommand } = require('./src/graph/command/server/RequestCommands');

JSG.UpdateSheetNamesCommand = UpdateNamesCommands.UpdateSheetNamesCommand;
JSG.SetGraphItemsCommand = UpdateNamesCommands.SetGraphItemsCommand;
JSG.RequestCommand = RequestCommand;
JSG.CompoundRequestCommand = CompoundRequestCommand;

JSG.SetBezierLineShapePointCommand = require('./src/graph/command/SetBezierLineShapePointCommand');
JSG.SetAttributesMapCommand = require('./src/graph/command/SetAttributesMapCommand');
JSG.SetTextSizeModeCommand = require('./src/graph/command/SetTextSizeModeCommand');
JSG.ResizeEdgeCommand = require('./src/graph/command/ResizeEdgeCommand');
JSG.SetAttributeAtPathCommand = require('./src/graph/command/SetAttributeAtPathCommand');
JSG.SetLayoutCommand = require('./src/graph/command/SetLayoutCommand');
JSG.SetLayoutSettingCommand = require('./src/graph/command/SetLayoutSettingCommand');
JSG.CommandFactory = require('./src/graph/command/CommandFactory');
JSG.AttributeRegistry = require('./src/graph/attr/AttributeRegistry');
JSG.ContraintRegistry = require('./src/graph/expr/ConstraintRegistry');
JSG.ExpressionRegistry = require('./src/graph/expr/ExpressionRegistry');
JSG.Property = require('./src/graph/properties/Property');
JSG.IndexProperty = require('./src/graph/properties/IndexProperty');
JSG.Properties = require('./src/graph/properties/Properties');
JSG.GraphItemProperties = require('./src/graph/properties/GraphItemProperties');
JSG.PropertiesProvider = require('./src/graph/properties/PropertiesProvider');
JSG.Notification = require('./src/graph/notifications/Notification');
JSG.NotificationCenter = require('./src/graph/notifications/NotificationCenter');
JSG.ContentNode = require('./src/graph/model/ContentNode');
JSG.Settings = require('./src/layout/Settings');
JSG.SettingsRegistry = require('./src/layout/SettingsRegistry');
JSG.Layout = require('./src/layout/Layout');
JSG.GraphLayout = require('./src/layout/GraphLayout');
JSG.EdgeLayout = require('./src/layout/EdgeLayout');
JSG.OrthogonalLayout = require('./src/layout/OrthogonalLayout');
JSG.GridLayout = require('./src/layout/GridLayout');
JSG.MatrixLayout = require('./src/layout/MatrixLayout');
JSG.Line = require('./src/layout/Line');
JSG.LayoutFactory = require('./src/layout/LayoutFactory');
JSG.CommandUtils = require('./src/graph/command/utils');
JSG.CellRange = require('./src/graph/model/CellRange');
JSG.LayoutCellAttributes = require('./src/graph/attr/LayoutCellAttributes');
JSG.TreeItemAttributes = require('./src/graph/attr/TreeItemAttributes');
JSG.SetPlotDataCommand = require('./src/graph/command/SetPlotDataCommand');
JSG.SetChartFormulaCommand = require('./src/graph/command/SetChartFormulaCommand');
JSG.ExecuteFunctionCommand = require('./src/graph/command/ExecuteFunctionCommand');
JSG.SetTreeItemDataCommand = require('./src/graph/command/SetTreeItemDataCommand');
JSG.SetTreeItemDepthCommand = require('./src/graph/command/SetTreeItemDepthCommand');
JSG.SetTreeShowDepthCommand = require('./src/graph/command/SetTreeShowDepthCommand');
JSG.SetTreeItemShowDepthCommand = require('./src/graph/command/SetTreeItemShowDepthCommand');
JSG.SetTreeItemDisabledCommand = require('./src/graph/command/SetTreeItemDisabledCommand');
JSG.SetTreeItemExpandFlagCommand = require('./src/graph/command/SetTreeItemExpandFlagCommand');
JSG.SetTreeItemCheckedFlagCommand = require('./src/graph/command/SetTreeItemCheckedFlagCommand');
JSG.SetTreeDataCommand = require('./src/graph/command/SetTreeDataCommand');
JSG.AddTreeItemCommand = require('./src/graph/command/AddTreeItemCommand');
JSG.DeleteTreeItemCommand = require('./src/graph/command/DeleteTreeItemCommand');
JSG.UpdateTreeItemCommand = require('./src/graph/command/UpdateTreeItemCommand');
JSG.UpdateNamesCommands = require('./src/graph/command/UpdateNamesCommands');
JSG.PasteTreeItemCommand = require('./src/graph/command/PasteTreeItemCommand');
JSG.AddSheetNameCommand = require('./src/graph/command/AddSheetNameCommand');
JSG.SetSheetNameCommand = require('./src/graph/command/SetSheetNameCommand');
JSG.DeleteSheetNameCommand = require('./src/graph/command/DeleteSheetNameCommand');
JSG.AddLayoutSectionCommand = require('./src/graph/command/AddLayoutSectionCommand');
JSG.SetLayoutSectionCommand = require('./src/graph/command/SetLayoutSectionCommand');
JSG.DeleteLayoutSectionCommand = require('./src/graph/command/DeleteLayoutSectionCommand');
JSG.SetSheetCellsCommand = require('./src/graph/command/SetSheetCellsCommand');
JSG.SetCellsCommand = require('./src/graph/command/SetCellsCommand');
JSG.SetCellLevelsCommand = require('./src/graph/command/SetCellLevelsCommand');
JSG.Selection = require('./src/graph/model/Selection');
JSG.SheetModel = require('./src/graph/model/SheetModel');
JSG.SetHeaderSectionLevelCommand = require('./src/graph/command/SetHeaderSectionLevelCommand');
JSG.SetHeaderSectionOutlineFlagCommand = require('./src/graph/command/SetHeaderSectionOutlineFlagCommand');
JSG.CreateHeaderLevelsFromRangeCommand = require('./src/graph/command/CreateHeaderLevelsFromRangeCommand');
JSG.SheetCommandFactory = require('./src/graph/command/SheetCommandFactory');
JSG.ExpressionHelper = require('./src/graph/expr/ExpressionHelper');
JSG.SheetName = require('./src/graph/model/SheetName');
JSG.Cell = require('./src/graph/model/Cell');
JSG.CellsNode = require('./src/graph/model/CellsNode');
JSG.ColumnHeaderNode = require('./src/graph/model/ColumnHeaderNode');
JSG.DataProvider = require('./src/graph/model/DataProvider');
JSG.CaptionNode = require('./src/graph/model/CaptionNode');
JSG.ButtonNode = require('./src/graph/model/ButtonNode');
JSG.LayoutSection = require('./src/graph/model/LayoutSection');
JSG.LayoutCell = require('./src/graph/model/LayoutCell');
JSG.LayoutNode = require('./src/graph/model/LayoutNode');
JSG.SheetButtonNode = require('./src/graph/model/SheetButtonNode');
JSG.SheetCheckboxNode = require('./src/graph/model/SheetCheckboxNode');
JSG.SheetJsonNode = require('./src/graph/model/SheetJsonNode');
JSG.SheetSliderNode = require('./src/graph/model/SheetSliderNode');
JSG.SheetKnobNode = require('./src/graph/model/SheetKnobNode');
JSG.HeaderNode = require('./src/graph/model/HeaderNode');
JSG.HeaderSection = require('./src/graph/model/HeaderSection');
JSG.HeaderModel = require('./src/graph/model/HeaderModel');
JSG.StreamSheetContainer = require('./src/graph/model/StreamSheetContainer');
JSG.StreamSheetsContainer = require('./src/graph/model/StreamSheetsContainer');
JSG.MachineContainer = require('./src/graph/model/MachineContainer');
JSG.MessageContainer = require('./src/graph/model/MessageContainer');
JSG.InboxContainer = require('./src/graph/model/InboxContainer');
JSG.OutboxContainer = require('./src/graph/model/OutboxContainer');
JSG.StreamSheet = require('./src/graph/model/StreamSheet');
JSG.StreamSheetModel = require('./src/graph/model/StreamSheetModel');
JSG.RowHeaderNode = require('./src/graph/model/RowHeaderNode');
JSG.ScrollbarNode = require('./src/graph/model/ScrollbarNode');
JSG.SheetHeaderNode = require('./src/graph/model/SheetHeaderNode');
JSG.SplitterNode = require('./src/graph/model/SplitterNode');
JSG.WorksheetNode = require('./src/graph/model/WorksheetNode');
JSG.TreeNode = require('./src/graph/model/TreeNode');
JSG.TreeItemsNode = require('./src/graph/model/TreeItemsNode');
JSG.TreeItem = require('./src/graph/model/TreeItem');
JSG.GraphItemFactory = require('./src/graph/model/GraphItemFactory');

const { SheetPlotNode } = require('@cedalo/jsg-extensions/core');

JSG.SheetPlotNode = SheetPlotNode;

const GraphItemFactory = require('./src/graph/model/GraphItemFactory');

Object.assign(JSG.jsg, {
	/* eslint-disable */
	graphItemFactory: new GraphItemFactory(),
	/* eslint-enable */
});
